import React from "react";

export default function RadioInput({
  className = "input",
  name,
  value,
  disabled = false,
  checked = false,
  onChange = null,
  attributes = {},
  defaultChecked,
}) {
  return (
    <div className="input-group__field">
      <input
        type="radio"
        name={name}
        className={className}
        value={value}
        disabled={disabled}
        checked={checked}
        onChange={onChange}
        {...attributes}
        defaultChecked={defaultChecked}
      />
      <div className="input__wrapper">
        <div className={"input__box" + (disabled ? " is-disabled" : "")}>
          <div className="input__check" />
        </div>
      </div>
    </div>
  );
}
